import React from "react";

export default function homeSection() {
  return (
    <>
      <div className="app-wrapper">
        <div className="app-content pt-3 p-md-3 p-lg-4">
          <div className="container-xl"></div>
        </div>
      </div>
    </>
  );
}
